import { Component, OnDestroy, OnInit } from '@angular/core';
import { PartnerDto, ResultListDto, SearchResultDocumentDto } from '../../service/dto';
import { OnTableChange, TableColumn } from '../../components/table/table.component';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import { HttpPartnerService } from '../../service/http-partner.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
	selector: 'app-partner-list',
	standalone: false,
	templateUrl: './partner-list.component.html',
	styleUrl: './partner-list.component.scss'
})
export class PartnerListComponent implements OnInit, OnDestroy {
	results?: ResultListDto<PartnerDto>;
	loading = false;

	columnRef: TableColumn[] = [
		{ "title": "Logo", "cellRef": "logo" },
		{ "title": "Partner", "property": "name" },
		{ "title": "Contact Person", "cellRef": "contact", exportValue: item => item.contacts[0]?.fullName }
	];

	constructor(private service: HttpPartnerService, private router: Router, private sanitizer: DomSanitizer) {
	}

	ngOnInit(): void {
		this.doFetchResults({
			filters: [],
			pageIndex: 0,
			pageSize: 0
		});
	}

	ngOnDestroy(): void {
	}

	trackByHashCode(index: number, item: SearchResultDocumentDto): any {
		return item.hashCode;
	}
	open(input: PartnerDto){
		this.router.navigate(['partner','view',input.id]);
	}

	doFetchResults(input: OnTableChange) {
		this.loading = true;
		this.service.getAll()
			.pipe(finalize(() => {
				this.loading = false;
			}))
			.subscribe(result => {
				this.results = result;
			});
	}
	getLogoUrl(row: PartnerDto){
		let out = (row.image as any)['safeUrl'];
		if(out){
			return out;
		}
		out = this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + row.image!.imageData);
		(row.image as any)['safeUrl'] = out;
		return out;
	}
}
